import {Route, Redirect} from "react-router-dom"
import React, { Component } from 'react';
import { connect } from 'react-redux';

class PublicRoute extends Component {
    state = {  }
    render() {
        if(!this.props.user){
            return (
                <Route exact={this.props.exact} path={this.props.path}> {this.props.children} </Route>  
            )
        }else{
            //pretty much used for page refreshes
            let redirectTo = this.props.location.state ? this.props.location.state.last : 'print'
            return (
                <Redirect to={redirectTo}/>
            )
        }
    }
}
function mapStateToProps(state){
    return{
        user: state.user
    }
  }
export default connect(mapStateToProps)(PublicRoute);
